import { all, call } from "redux-saga/effects";

import dietanamnezSaga from "./modules/dietanamnez/saga";
import { saga as dietanamnezItemSaga } from "./modules/dietanamnezItem";

export function* saga() {
  yield all([call(dietanamnezSaga), call(dietanamnezItemSaga)]);
}
